<script>
  import { onMount } from 'svelte';
  import { blur, fade, fly } from 'svelte/transition';
  import { writable } from 'svelte/store';

  export let title = "Ready, Player Two?"

  export const visitor = writable({
    name: "",
    locationData: null,
    locationText: null
  });

  function fadeIn(node, { delay, duration }) {
		return {
      delay,
			duration,
			css: t => ``
		};
	}

  onMount(async () => {
    // Visitor IP address
    const ipResp = await fetch("https://api.ipify.org?format=json&callback=getIP");
    const ipData = await ipResp.json();

    // Location of visitor IP address
    const locResp = await fetch(`https://ipwhois.app/json/${ipData.ip}`);
    const locData = await locResp.json();

    if (locData && locData.success) {
      visitor.locationData = locData;

      let globeIcon;
      if (locData.longitude > 60) {
        // Asia-Australia
        globeIcon = "🌏";
      } else if (locData.longitude > -30) {
        // Africa-Europe
        globeIcon = "🌍";
      } else {
        // Americas
        globeIcon = "🌎";
      }

      // Set location text after timeout.
      // Triggers animated transition on UI.
      setTimeout( function() {
        visitor.locationText = `${globeIcon} ${locData.city}, ${locData.country}`;
      }, 4000);
    }
  });
</script>

<svelte:head>
  <title>{title}</title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
  <style>
    @import url('https://fonts.googleapis.com/css2?family=Raleway&family=Electrolize&display=swap');
  </style>
</svelte:head>

<style type="text/scss">
  @import "./styles.scss";

  main {
    align-content: center;
    box-sizing: border-box;
    display: grid;
    font-family: $font-family-normal;
    hyphens: auto;
    line-height: 1.65;
    margin: 0 auto;
    max-width: 680px;
    min-height: 100vh;
    padding: 72px 0;
    text-align: center;
  }
  h1 {
    font-size: 45px;
    font-family: $font-family-header;
    @include neon-text;
  }
  h2 {
    margin-top: 1.5em;
    font-size: 24px;
    font-family: $font-family-header;
    font-weight: normal;
    @include neon-text;
  }
  p {
    font-size: 16px;
  }
  a {
    border-bottom: 1px solid white;
    color: $secondary-blue;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.2s ease;
  }
  a:hover {
    border-bottom: 1px solid $secondary-blue;
  }
  code,
  pre {
    color: $primary-magenta;
    font-family: $font-family-code;
    font-size: 0.92em;
  }
  code:before,
  code:after {
    content: '\`';
  }

  .main-header-container {
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    padding: 24px 0;
  }

  .minigame-container {
    padding: 48px 0;
  }

  .minigame-player-avatars-row {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .minigame-player-avatar {
    width: 36%;

    img {
      max-width: 100%;
      height: auto;
    }
  }

  .minigame-between-player-avatars-container {
    height: 100%;
    width: 16%;
    position: relative;
    
  }

  .expand-x-20 {
    position: absolute; 
    height: 100%;
    width: 140%;
    margin: 0 -20%;
  }

  .minigame-between-player-avatars-content {
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    font-family: $font-family-header;
    font-weight: normal;
    @include neon-text;
    line-height: 1;
  }

  a#minigame-play-button {
    width: 100%;
    color: $primary-dark;
    background-color: transparent;
    border: none;
  }

  .minigame-player-details-row {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: flex-start;
  }

  .minigame-player-details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 50%;
  }

  .minigame-player-name-input-box {
    position: relative;
    border: solid 3px;
    @include neon-box-shadow;
    border-radius: 2em;
    margin: 6px 5%;
    padding: 12px 6px;

    label {
      position: absolute;
      left: 18px;
      top: -18px;
      background: white;
      padding: 3px;
    }

    .minigame-player-name-input-wrapper {
      position: relative;
      width: 100%;
      overflow: hidden;
    }

    input {
      width: 100%;
      border: none;
      margin: 0;
      padding: 2px 0 0 0;
      text-align: center;
      font-size: 1.25em;
      font-family: $font-family-normal;

      &:focus {
        outline: none;
      }
    }
  }

  input#minigame-player-two-name::-webkit-input-placeholder {
    animation: blinker 1.5s linear infinite;
    -webkit-animation: blinker 1.5s linear infinite;
  }

  .minigame-player-location {
    font-size: 1em;
    height: 28px;
    position: relative;

    .overlapping {
      width: 100%;
      height: 100%;   
      position: absolute;
      top: 0;
      left: 0;
    }
  }

  .vertical-divider {
    width: 75%;
    height: 45px;
    margin-right: auto;
    margin-left: auto;
    background-image: url(/divider.png);
    background-repeat: no-repeat;
    background-position: center;
    -webkit-background-size: 75% 75%;
    background-size: 75%;
  }

  .social-links {
    color: #000000;

    a:hover {
      text-decoration: none;
      border-bottom: none;
    }

    .fa {
      padding: 10px;
    }
  }

  .glitch-components {
    font-weight: normal;
    letter-spacing: 1px;
    position: relative;
    line-height: 1;
  }

  .glitch-symbol {
    position: absolute;
    top: 0;
    transform: translate(-50%, -50%);
    white-space: nowrap;
    text-indent: 10px;
    animation-name: glitch-symbol-move;
    animation-iteration-count: infinite;
    
    &.shallow {
      left: 1px;
      z-index: 2;
      text-shadow: 3px 0 $primary-magenta;
      animation-duration: 1.9s;
    }
    &.deep {
      left: 0;
      z-index: 3;
      text-shadow: 3px 0 $primary-cyan;
      mix-blend-mode: darken;
      animation-duration: 2.2s;
      animation-delay: 0.2s;
    }
  }

  @media only screen and (max-width: 480px) {
    .glitch-symbol {
      transform: translate(-50%, -50%) scale(0.8);
    }
  }

  .glitch-line {
    position: absolute;
    z-index: 4;
    transform: translate(-50%, -50%);
    width: 100vw;
    height: 2px;
    background-color: white;
    animation: glitch-line-move 8s ease-out infinite;
  }

  @keyframes glitch-symbol-move {
    10% { top: -0.8px; left: -2.2px; }
    20% { top: 0.8px; left: -0.4px; }
    30% { left: 1px; }
    40% { top: -0.6px; left: -1.4px; }
    50% { left: 0.4px; }
    60% { top: 3px; left: -2.4px; }
    70% { top: -2px; left: 0.2px; }
    80% { top: -0.8px; left: -1.8px; }
    90% { left: 2.4px; }
    100% { left: -2.4px; }
  }

  $symbol-height: 36px * 1 * 3 !default;

  @keyframes glitch-line-move {
    0% { top: -60px; }
    9% { top: 25px; }
    14% { top: -30px }
    18% { top: 40px; }
    22% { top: -25px; }
    32% { top: 45px; }
    34% { top: -10px; }
    40% { top: 35px; }
    43% { top: -25px; }
    99% { top: 45px; }
    100% { top: 60px }
  }

  .blink {
    animation: blinker 1s linear infinite;
    -webkit-animation: blinker 1s linear infinite;
  }

  @keyframes blinker {  
    50% { opacity: 0.2; }
  }

  .connecting-container {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    overflow: hidden;
  }

  .connecting-dots {
    position: relative;
    top: 5px;
    left: -9985px;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background-color: #000000;
    color: #000000;
    box-shadow: 9991px -9px 0 0 #000000, 9991px 0 0 0 #000000, 10002px 0 0 0 #000000;
    animation: dotBricks 3s infinite ease;
  }

  @keyframes dotBricks {
    0%      { box-shadow: 9991px -9px 0 0 #000000, 9991px 0 0 0 #000000, 10002px 0 0 0 #000000; }
    8.333%  { box-shadow: 10002px -9px 0 0 #000000, 9991px 0 0 0 #000000, 10002px 0 0 0 #000000; }
    16.667% { box-shadow: 10002px -9px 0 0 #000000, 9991px -9px 0 0 #000000, 10002px 0 0 0 #000000; }
    25%     { box-shadow: 10002px -9px 0 0 #000000, 9991px -9px 0 0 #000000, 9991px 0 0 0 #000000; }
    33.333% { box-shadow: 10002px 0 0 0 #000000, 9991px -9px 0 0 #000000, 9991px 0 0 0 #000000; }
    41.667% { box-shadow: 10002px 0 0 0 #000000, 10002px -9px 0 0 #000000, 9991px 0 0 0 #000000; }
    50%     { box-shadow: 10002px 0 0 0 #000000, 10002px -9px 0 0 #000000, 9991px -9px 0 0 #000000; }
    58.333% { box-shadow: 9991px 0 0 0 #000000, 10002px -9px 0 0 #000000, 9991px -9px 0 0 #000000; }
    66.666% { box-shadow: 9991px 0 0 0 #000000, 10002px 0 0 0 #000000, 9991px -9px 0 0 #000000; }
    75%     { box-shadow: 9991px 0 0 0 #000000, 10002px 0 0 0 #000000, 10002px -9px 0 0 #000000; }
    83.333% { box-shadow: 9991px -9px 0 0 #000000, 10002px 0 0 0 #000000, 10002px -9px 0 0 #000000; }
    91.667% { box-shadow: 9991px -9px 0 0 #000000, 9991px 0 0 0 #000000, 10002px -9px 0 0 #000000; }
    100%    { box-shadow: 9991px -9px 0 0 #000000, 9991px 0 0 0 #000000, 10002px 0 0 0 #000000; }
  }

  .icon-3d {
    animation: icon3d 800ms infinite;
    color: $primary-dark;
  }

  @keyframes icon3d {
    0%    { text-shadow:  1px  2px $primary-magenta, -3px -1px $primary-cyan; }
    12.5% { text-shadow: -1px -3px $primary-magenta,  2px  1px $primary-cyan; }
    25%   { text-shadow:  1px -2px $primary-magenta,  0px -1px $primary-cyan; }
    37.5% { text-shadow: -2px -2px $primary-magenta, -2px -2px $primary-cyan; }
    50%   { text-shadow: -2px -2px $primary-magenta, -2px -2px $primary-cyan; }
    62.5% { text-shadow: -1px  1px $primary-magenta,  0px -2px $primary-cyan; }
    75%   { text-shadow: -1px  1px $primary-magenta,  0px -2px $primary-cyan; }
    87.5% { text-shadow: -1px  1px $primary-magenta,  0px -2px $primary-cyan; }
    100%  { text-shadow: -1px  1px $primary-magenta,  0px -2px $primary-cyan; }
  }

</style>

<main>  
  <div class="main-header-container">
    <h1 class="glitch-components">
      <span class="glitch-symbol shallow">Ready, Player Two?</span>
      <span class="glitch-symbol deep">Ready, Player Two?</span>
      <span class="glitch-line"></span>
    </h1>
  </div>

  <p>“A little step may be the beginning of a great journey.”</p>

  <div class="minigame-container">

    <div class="minigame-player-avatars-row">
      <div class="minigame-player-avatar">
        <img src="avatar-joonas.png" alt="" />
      </div>
      <div class="minigame-between-player-avatars-container">
        <div class="expand-x-20">
        {#if visitor.name && visitor.name.length}
          <div class="minigame-between-player-avatars-content"
            in:blur="{{amount: 10, delay: 250, duration: 500}}"
            out:blur="{{amount: 10, delay: 0, duration: 500}}">
            <a
              id="minigame-play-button"
              href="https://youtu.be/dQw4w9WgXcQ"
              target="_blank"
              rel="noreferrer noopener"
              >
                <i class="fa fa-play-circle fa-2x icon-3d"></i>
                <br/>Let's go
            </a>
          </div>
        {:else}
          <div class="minigame-between-player-avatars-content"
            in:blur="{{amount: 10, delay: 0, duration: 500}}"
            out:blur="{{amount: 10, delay: 250, duration: 500}}">
            <span>Waiting ...</span>
          </div>
        {/if}
        </div>
      </div>
      <div class="minigame-player-avatar">
        <img src="avatar-doge.png" alt="" />
      </div>
    </div>

    <div class="minigame-player-details-row">
      <div class="minigame-player-details">
        <form>
          <div class="minigame-player-name-input-box">
            <label for="minigame-player-one-name">Player One</label>
            <div class="minigame-player-name-input-wrapper">
              <input id="minigame-player-one-name" type="text" value="Joonas" readonly="readonly">  
            </div>                  
          </div>
          <div class="minigame-player-location">🌍 Helsinki, Finland</div>
        </form>
      </div>
      <div class="minigame-player-details">
        <form on:submit|preventDefault>
          <div class="minigame-player-name-input-box">
            <label for="minigame-player-two-name">Player Two</label>
            <div class="minigame-player-name-input-wrapper">
              <input id="minigame-player-two-name" type="text" placeholder="Enter name" bind:value={visitor.name}>
            </div>
          </div>
        </form>
        <div class="minigame-player-location">
          {#if visitor.locationText}
            <div class="overlapping" in:fade="{{duration: 1500}}">
              {visitor.locationText}
            </div>
          {:else}
            <div class="overlapping" out:fly="{{ x: 200, duration: 1000 }}">
              <div class="connecting-container">Connecting<div class="connecting-dots"></div></div>
            </div>
          {/if}
        </div>

      </div>

    </div>
  </div>

  <p>
    Ohaithere! You might have wandered here looking for some info about me, amiright?
    <br/>
    Well, then ... I'm a tinkerer who easily gets absorbed into experimenting with new concepts, ideas and technologies.
    At the time being my professional interest areas include
    <a href="https://www.rust-lang.org" target="_blank" rel="noreferrer noopener">
      🦀 Rust lang
    </a>,
    <a href="https://en.wikipedia.org/wiki/General-purpose_computing_on_graphics_processing_units" target="_blank" rel="noreferrer noopener">
      🖥️ GPGPU
    </a>
    and
    <a href="https://en.wikipedia.org/wiki/Cloud_gaming" target="_blank" rel="noreferrer noopener">
      🎮 cloud gaming
    </a>.
  </p>
  <p>
    Outside work I like to do calisthenics, cold exposure training and
    spend some time in nature once in a while for the sake of, well ... calm mind and happiness.
    An aspiring sailing boat skipper, too, for that matter.
    And yeah I also think doggos are pretty cool.
  </p>

  <p>
    If you'd like to get in touch, feel free to reach out to me at <i>firstname.lastname@gmail.com</i>
    or find more about me or my work on the following platforms.
  </p>
  
  <div class="social-links">
    <a href="https://twitter.com/JoonasSatka" target="_blank" rel="noreferrer noopener">
      <i class="fa fa-twitter fa-4x icon-3d"></i>
    </a>
    <a href="https://www.linkedin.com/in/joonassatka/" target="_blank" rel="noreferrer noopener">
      <i class="fa fa-linkedin fa-4x icon-3d"></i>
    </a>
    <a href="https://github.com/jsatka" target="_blank" rel="noreferrer noopener">
      <i class="fa fa-github fa-4x icon-3d"></i>
    </a>
    <a href="https://instagram.com/joonassatka" target="_blank" rel="noreferrer noopener">
      <i class="fa fa-instagram fa-4x icon-3d"></i>
    </a>
  </div>

</main>
